const OverviewUtilizationCard = ({ title = '', liner = '', classes = '', btnText = '', btnHandler = () => {}, }) => {
  return (
    <div className={`bg-white border border-gray-275 rounded-lg flex flex-col items-center justify-center py-8 px-9 text-center ${classes}`}>
      <h1 className='text-3xl text-gray-900 mb-0 font-semibold'>{title}</h1>
      <p className='text-sm text-gray-500 mb-0 mt-1.5 font-semibold'>{liner}</p>
      {btnText && <h1 className='text-blue-600 font-semibold text-sm mt-1.5 cursor-pointer' onClick={btnHandler}>{btnText}</h1>}
    </div>
  )
}

export default OverviewUtilizationCard